import styled from "styled-components";

export const Text = styled.div`
    font-size: 15px;
    margin-bottom: 15px;
    width: 85%;
    margin-left: 10px;
`

export const TextButtonBoxContainer = styled.div`
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
`